<template>
  <v-fab-transition>
    <v-btn id="to-top" v-show="fab" v-scroll="onScroll" @click="toTop" fab="fab" small dark="dark" fixed="fixed" bottom="bottom" right="right" color="red">
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
  export default {
    name: 'AppFab',

    data: () => ({
      fab: false,
    }),

    methods: {
      onScroll() {
        if (typeof window === 'undefined') return;

        const top = window.pageYOffset || document.documentElement.offsetTop || 0;

        this.fab = top > 300;
      },
      toTop() {
        this.$router.push({ hash: '' });
        this.$vuetify.goTo(0);
      },
    },
  };
</script>

<style scoped>
  #to-top {
    opacity: 0.5;
  }
</style>
